/**
 * Custom hook to refresh ads on route change in SPA
 * Handles WGPlayer and Google Adsense refresh
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useAdsRefresh() {
  const location = useLocation();

  useEffect(() => {
    // Reload WGPlayer ads on route change
    // const reloadWGPlayerAds = () => {
    //   // Remove existing WGPlayer script
    //   const existingScript = document.querySelector('script[src*="universal.wgplayer.com/tag"]');
    //   if (existingScript) {
    //     existingScript.remove();
    //   }

    //   // Create and inject new WGPlayer script with updated path
    //   const script = document.createElement('script');
    //   script.type = 'text/javascript';
    //   script.async = true;
    //   script.fetchPriority = 'high' as any;
    //   script.src = `https://universal.wgplayer.com/tag/?lh=${window.location.hostname}&wp=${window.location.pathname}&ws=${window.location.search}`;
      
    //   const firstScript = document.getElementsByTagName('script')[0];
    //   if (firstScript && firstScript.parentNode) {
    //     firstScript.parentNode.insertBefore(script, firstScript);
    //   }
    // };

    // Refresh Google Adsense ads
    const refreshGoogleAds = () => {
      try {
        // Push new ad request to Google Adsense
        if (typeof window !== 'undefined' && (window as any).adsbygoogle) {
          const adsbygoogle = (window as any).adsbygoogle;
          // Refresh all ad slots on the page
          const adElements = document.querySelectorAll('.adsbygoogle');
          adElements.forEach((adElement) => {
            if (adElement.getAttribute('data-ad-status') !== 'filled') {
              adsbygoogle.push({});
            }
          });
        }
      } catch (error) {
        console.warn('Error refreshing Google Ads:', error);
      }
    };

    // Small delay to ensure page is ready
    const timer = setTimeout(() => {
      // reloadWGPlayerAds();
      refreshGoogleAds();
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname, location.search]); // Re-run when path or search params change
}
